// extracted by mini-css-extract-plugin
module.exports =  {"ErrorBoundary":"qtqazyQG5GgStnu19USR"};